module.exports = __webpack_public_path__ + "img/20.220d229f.jpg";